// extracted by mini-css-extract-plugin
export default {"fullWidthInput":"style_fullWidthInput__qV2XI"};